/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档

  
    
export interface IAPI73398ResRecordsItemActionsItem {
  
  /**  */
  label?: string;
  
  /**  */
  value?: string;
  
  /**  */
  isSelect?: number;
  
};
    
  
    
export interface IAPI73398ResRecordsItem {
  
  /**  */
  id?: string;
  
  /**  */
  sendTime?: string;
  
  /**  */
  content?: string;
  
  /**  */
  source?: string;
  
  /** ActionResp */
  actions?: IAPI73398ResRecordsItemActionsItem[];
  
};
    
  



export interface API73398Req {
  
  /** 会话id */
  sessionToken: string;
  /** 选项值 */
  action: string;
  /** 上一条聊天记录Id */
  lastRecordId?: string;
  /** 回复聊天记录值 */
  message?: string;
};



export interface API73398Res {
  /** 会话标识Id  */
  sessionToken?: string;
  /** 会话记录 ,ChatRecordResp  */
  records?: IAPI73398ResRecordsItem[];
  
};


// 接口函数 73398 /chat/record/action

export interface IUsePostAPI73398Return {
  /** /chat/record/action: 接口请求状态 */
  isAPI73398Loading: boolean;
  /** /chat/record/action: 接口请求返回数据 */
  dataAPI73398: API73398Res;
  /**  /chat/record/action: 接口数据请求方法 */
  fetchAPI73398Data: (inputs: API73398Req, config?: YWRequestConfig) => Promise<API73398Res>;
  /** /chat/record/action: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI73398 = ():IUsePostAPI73398Return => {
  let isMount = true;
  const [isAPI73398Loading, setIsAPI73398Loading] = useState(false);
  const [dataAPI73398, setDataAPI73398] = useState<API73398Res>({} as API73398Res);
  const requestUrl = `${basePath}/yoaichat-web/chat/record/action`;

  const fetchAPI73398Data = async (inputs: API73398Req, config?: YWRequestConfig): Promise<API73398Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API73398Req>) || {}) as API73398Req;
    
  
    if ( isMount ) {
      setIsAPI73398Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API73398Res>(`${basePath}/yoaichat-web/chat/record/action`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI73398(res || {} as API73398Res);
        setIsAPI73398Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI73398Loading(false);
      }
      return false as unknown as API73398Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI73398Loading,
    dataAPI73398,
    fetchAPI73398Data,
    requestUrl,
  }
}

